import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { openNotification } from 'src/components/helpers/notification';
import ax from 'src/store/config';


const initialState = {
    bookingList: null,
    bookingListLoading: false
};

export const bookingAction = createAsyncThunk('bookingAction', async (payload, { dispatch }) => {
    dispatch(setBookingListLoading(true))
    try {
        let data;
        const url = '/api/admin/directory/booking';
        switch (payload.flag) {
            case 'get':
                ({ data } = await ax.get(url, { params: payload.value }))
                data && dispatch(setBookingListLoading(false))
                return data

            case 'post':
                ({ data } = await ax.post(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Бронирование успешно отредактировано`
                })
                break;

            case 'put':
                ({ data } = await ax.put(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Бронирование успешно добавлено`
                })
                break;

            case 'delete':
                ({ data } = await ax.delete(url, { params: payload.value }))
                data && openNotification({
                    type: 'success',
                    message: `Бронирование успешно удалено`
                })
                break;

            default:
                break;
        }
    } catch (error) {
        dispatch(setBookingListLoading(false))
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

const BookingSlice = createSlice({
    name: 'booking',
    initialState,
    reducers: {
        setBookingListLoading: (state, action) => {
            state.bookingListLoading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(bookingAction.fulfilled, (state, action) => {
            state.bookingList = action.payload
        })
    }
});

export const { setBookingListLoading } = BookingSlice.actions;

export default BookingSlice.reducer